
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'paper-plane': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path d="M17.5 2.5L2.5 8.775V9.59167L8.2 11.8L10.4 17.5H11.2167L17.5 2.5Z" fill="#93A0AE"/>'
  }
})
